import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from '@app/modules/live/services/utility.service';
import { FaIconListComponent } from './components/fa-icon-list/fa-icon-list.component';
import { IconModel } from './models/icon-model';

@Component({
    selector: 'app-icon-selector',
    templateUrl: './icon-selector.component.html',
    styleUrls: ['./icon-selector.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => IconSelectorComponent),
            multi: true
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconSelectorComponent implements OnInit, ControlValueAccessor {

  private _value: string;
  isDisabled: boolean;

  @Input()
  public get value(): string {
    return this._value;
  }

  public set value(val: string) {
    if (this._value === val) { return; }
    this._value = val;
    const icon = this.utilityService.resolveIcon(val);
    this.selectedIcon = new IconModel(icon[0], icon[1]);
    this.onChange(val);
    this.onTouch(val);
    this.valueChange.emit(this.value);
  }

  @Output()
  valueChange = new EventEmitter<string>();

  @Input() externalClass: string;

  @Input()
  label: string;

  _selectedIcon: IconModel;

  get selectedIcon(): IconModel {
    return this._selectedIcon;
  }

  set selectedIcon(val: IconModel) {
    this._selectedIcon = val;
    this.value = val.iconString;
  }

  onChange: any = () => {
  };
  onTouch: any = () => { };

  constructor(
    public dialog: MatDialog,
    public utilityService: UtilityService) { }

  ngOnInit(): void {
  }


  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }


  openDialog(): void {

    const dialogRef = this.dialog.open(FaIconListComponent, {
      width: '960px',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: 'calc(100vh - 2rem)',
      autoFocus: false,
      panelClass: 'frosty-dialog-panel',
      data: this.selectedIcon,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) { return; }
      this.selectedIcon = result;
    });

  }

}
